import { useState } from "react"
import { useCookies } from "react-cookie"
import PropTypes from "prop-types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import { loadState } from "shared/localstorage_helper"

import "./pro_diy_footer.scss"
import { ProDIYBannerAndFooterCopies } from "./utils/pro_diy_banner_copies"
import { validTimeframe } from "../promote_app_banner"

const ProDiyFooter = ({ cookieName, onClick, userTier, userId, showPromoteAppBanner }) => {
  const [cookies, setCookie] = useCookies([cookieName])
  const [hideFooter, setHideFooter] = useState(cookies[cookieName])
  const [showingPromoteAppBanner, setShowingPromoteAppBanner] = useState(true)

  if (hideFooter) {
    return null
  }
  // avoids overlap of multiple banners in the DIY composer
  if (userId) {
    const bannerState = loadState(`promoteAppBanner-${userId}`)

    if (bannerState) {
      setShowingPromoteAppBanner(validTimeframe(bannerState) && showPromoteAppBanner)
    }
  }

  const onHide = () => {
    logIFTTTNextAction("click", {
      object_type: "maybe_later_button",
      location_type: "diy_composer",
    })
    setCookie(cookieName, true)
    setHideFooter(true)
  }

  let bannerTitle = ProDIYBannerAndFooterCopies.title
  let buttonLabel = ProDIYBannerAndFooterCopies.buttonLabel

  if (userTier === "intermediate_pro") {
    bannerTitle = ProDIYBannerAndFooterCopies.titleForUpgradePro
  }

  return (
    <>
      {!showingPromoteAppBanner && (
        <>
          <div styleName="pro-diy-footer">
            <div>{bannerTitle}</div>
            <div styleName="button-container">
              <a className="button-tertiary button-on-color button-outlined" role="button" onClick={onHide}>
                Maybe later
              </a>
              <a
                data-turbolinks="false"
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify({
                  object_type: "get_pro_cta",
                  location_type: "diy_composer",
                })}
                className="button-tertiary button-on-color"
                onClick={onClick}
              >
                {buttonLabel}
              </a>
            </div>
          </div>
        </>
      )}
    </>
  )
}

ProDiyFooter.propTypes = {
  cookieName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  userTier: PropTypes.oneOf(["free", "intermediate_pro"]).isRequired,
  userId: PropTypes.string,
  showPromoteAppBanner: PropTypes.bool,
}

export default ProDiyFooter
